import React from 'react';
import { SquareAssetProps } from './types';
import AssetBase from './AssetBase';

/**
 * Square asset component that interfaces with the svg sprites
 */
const Square = (props: SquareAssetProps) => <AssetBase kind="square" {...props} />;

export default React.memo(Square);
